import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import find from 'lodash/find';
import map from 'lodash/map';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
//import includes from 'lodash/includes';
import SmallLoader from '../../../components/SmallLoader';
import { palletsValidator } from '../../../shared/utils/rowValidators';
import { palletsFormatter } from '../../../shared/utils/rowFormatters';
import { ABNORMALITIES } from '../../../constants';
import SeverityLabel from '../../../components/SeverityLabel/SeverityLabel';

const recoveryActionsFormatter = (cell, row, url) => {
    let recoveryActions = [];

    if (
        row.manifest &&
        row.manifest.allManifestRecoveryActions &&
        row.manifest.allManifestRecoveryActions.length > 0
    ) {
        recoveryActions = row.manifest.allManifestRecoveryActions;
    } else if (row.allManifestRecoveryActions && row.allManifestRecoveryActions.length > 0) {
        recoveryActions = row.allManifestRecoveryActions;
    } else {
        recoveryActions = row.recoveryActions;
    }

    if (recoveryActions && recoveryActions.length > 0) {
        return (
            <div>
                {map(recoveryActions, rec => {
                    if (rec.recoveryActionId) {
                        return (
                            <p key={rec.recoveryActionId}>
                                <Link
                                    to={`runs/${url.runId}/abnormality/${url.abnormalityType}/${
                                        url.abnormalityId
                                    }/recoveryAction/${rec.recoveryActionType}/${
                                        rec.recoveryActionId
                                    }`}
                                >
                                    {rec.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }

    return <div />;
};
const manifestNumberFormatter = (cell, row) => {
    if (row.manifestId) {
        return (
            <div>
                <p key={row.manifestId}>
                    <Link to={`manifests/${row.manifestId}`}>{row.manifestNumber}</Link>
                </p>
            </div>
        );
    }
};

const ghostFormatter = (cell, row) => {
    console.log(row.ghost);
    console.log(row);
    if (row.manifestId) {
        return (
            <div>
                <p key={row.manifestId}>
                    {row.ghost ? "True" : "False"}
                </p>
            </div>
        );
    }
};


const nonEditableRowsFilter = (abnormality, manifests, selectedManifests) => {
    /*const manifestsWithRecoveryActions = filter(manifests, manifest => {
        return (
            manifest.allManifestRecoveryActions && manifest.allManifestRecoveryActions.length > 0
        );
    }).map(man => man.manifestId);*/
    return filter(
        manifests,
        man =>
            !find(
                selectedManifests,
                selMan =>
                    man.manifestId === selMan /*&&
                    !includes(manifestsWithRecoveryActions, man.manifestId)*/
            )
    ).map(man => man.manifestId);
};

class ManifestsInfo extends React.Component {
    trClassFormat = (row, rowIndex, validations, selectedManifests) => {
        const found = findIndex(selectedManifests, selMan => row.manifestId === selMan);
        if (validations.pallets && !row.totalPallets && found > -1) {
            return 'error-row';
        }
    };

    render() {
        const {
            abnormality,
            abnormalityType,
            hideSeverity = true,
            manifests,
            selectedManifests,
            onCheckSelect,
            onCheckSelectAll,
            validations,
            onCellEdit,
            isFetching,
            isEditable,
            isSelectable = true,
            recoveryActionDetails = false,
            url,
        } = this.props;
        
        let options = {
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
            onCellEdit: null,
        };

        if (isEditable) {
            options.onCellEdit = onCellEdit;
        }

        return (
            <Panel collapsible defaultExpanded header="Manifests">
                {validations.manifests && (
                    <p style={{ color: '#CF142B', margin: 5 }}>{validations.manifests}</p>
                )}
                {validations.pallets && (
                    <p style={{ color: '#CF142B', margin: 5 }}>{validations.pallets}</p>
                )}
                {console.log(manifests)};
                <div>
                    <BootstrapTable
                        ref={c => {
                            this.table = c;
                        }}
                        data={manifests}
                        maxHeight={500}
                        hover
                        scrollTop={'Top'}
                        remote={true}
                        tableStyle={
                            validations.manifests && {
                                border: '#CF142B 2px solid',
                            }
                        }
                        multiColumnSort={2}
                        trClassName={(a, b) =>
                            this.trClassFormat(a, b, validations, selectedManifests)
                        }
                        options={options}
                        cellEdit={
                            isEditable
                                ? {
                                      mode: 'click',
                                      nonEditableRows: () =>
                                          nonEditableRowsFilter(
                                              abnormality,
                                              manifests,
                                              selectedManifests
                                          ),
                                      blurToSave: true,
                                  }
                                : {}
                        }
                        selectRow={
                            isSelectable
                                ? {
                                      mode: 'checkbox',
                                      onSelect: onCheckSelect,
                                      onSelectAll: onCheckSelectAll,
                                      selected: selectedManifests,
                                      unselectable: !isEditable
                                          ? map(manifests, man => man.manifestId)
                                          : [],
                                  }
                                : {}
                        }
                    >
                        <TableHeaderColumn dataField="manifestId" isKey hidden>
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="manifestNumber"
                            dataFormat={(cell, row) => manifestNumberFormatter(cell, row)}
                            editable={false}
                        >
                            Manifest
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField=""
                            editable={false}
                            dataFormat={(cell, row) =>
                                `${row.supplierCode}-${row.supplierPlantCode}`
                            }
                        >
                            Supplier
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField=""
                            editable={false}
                            dataFormat={(cell, row) => `${row.emcCode}-${row.emcPlantCode}`}
                        >
                            EMC
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="emcDockCode" editable={false} width="200">
                            EMC dock
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                            dataField="ghost"
                            editable={false} 
                            width="200"
                            dataFormat={(cell, row) => ghostFormatter(cell, row)}
                        >
                            Ghost
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="totalPallets"
                            editable={{
                                validator: palletsValidator,
                            }}
                            hidden={abnormalityType === ABNORMALITIES.DELAY}
                            dataFormat={(cell, row) =>
                                palletsFormatter(cell, row, selectedManifests, isEditable)
                            }
                            width="215"
                        >
                            Impacted # of pallets
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="severity"
                            editable={false}
                            hidden={hideSeverity}
                            dataFormat={(cell, row) => <SeverityLabel code={row.severity} />}
                            width="200"
                        >
                            Severity
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="allManifestRecoveryActions"
                            dataFormat={(cell, row) => recoveryActionsFormatter(cell, row, url)}
                            editable={false}
                            hidden={recoveryActionDetails}
                        >
                            Existing recovery actions
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="pLaneExit"
                            editable={false}
                            hidden={!recoveryActionDetails}
                        >
                            P-lane exit
                        </TableHeaderColumn>
                    </BootstrapTable>
                    {isEditable && (
                        <p>
                            <Glyphicon
                                glyph="info-sign"
                                className="text-primary"
                                style={{ margin: '20px 5px 0 0' }}
                            />{' '}
                            Number of pallets can't be changed once a manifest has recovery actions.
                        </p>
                    )}
                </div>
            </Panel>
        );
    }
}

export default ManifestsInfo;
